// extracted by mini-css-extract-plugin
module.exports = {"ListItemText":"DataPointVersionListItem_ListItemText__2VNjS"};